exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sidebar[data-v-127eac5b]{overflow-y:auto;border-right:1px solid #5a5b54\n}\n.horizontal-separator[data-v-127eac5b]{margin:0;padding:0;border-bottom:1px solid #5a5b54\n}", ""]);

// exports
